import { format } from 'date-fns';
import { ar, es, fr, ka } from 'date-fns/locale';
import en from 'date-fns/locale/en-US';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';

import { Typography } from '@/shared/components/atoms';

const EmptyDayCard: React.FC<{ day: Date }> = ({ day }) => {
  const { t } = useTranslation('common');
  const { locale } = useRouter();
  return (
    <div className='rounded-lg bg-white p-16'>
      <Typography variant='body2'>
        {t('no-dues-to-be-issued-in-date')}{' '}
        {format(day, locale === 'ar' ? 'yyyy/MM/d' : 'd/MM/yyyy', {
          locale:
            locale === 'ar'
              ? ar
              : locale === 'es'
              ? es
              : locale === 'fr'
              ? fr
              : locale === 'ka'
              ? ka
              : en,
        })}
      </Typography>
    </div>
  );
};

export { EmptyDayCard };
